import { Notification } from '@hs/hanshow-ui';
import store from "@/store";
import i18n from "@/i18n/index";
import router from '@/router';
import { getNoZeroCostTime } from '@/utils/utils';

export function responseHandle(res) {
    if (!res) {
        return;
    }
    if (res.resultCode != 1001) {
        let notShowNotify = false;

        Notification.closeAll();

        let messageCon = '';
        if (res.resultCode == 1002) {
            messageCon = i18n.t(`promptMessage.error1002`);
            switch (true) {

                case ['IO_ERRORFILEFORMAT', 'IO_ERRORNONEDATA', 'REFRESH', 'IO_NOCSVFILE'].includes(res.message):
                    messageCon = i18n.t(`promptMessage.${res.message}`);
                    break;

                case res.message.includes('IO_ERRORFILETOLONG'): {
                    let errorArr = res.message.split('.');
                    messageCon = `${i18n.t('promptMessage.IO_ERRORFILETOLONG')}${errorArr[1] ? errorArr[1] : ''}`;
                    break;
                }

                case res.message.includes("Couldn't connect to host"):
                    messageCon = i18n.t(`promptMessage.stmpHost`);
                    break;

                case res.message == 'used':
                    messageCon = i18n.t(`promptMessage.groupUsed`);
                    break;

                case res.errorContext == 'hummerUrl':
                    messageCon = i18n.t(`promptMessage.1002hummerUrl`);
                    break;

                case res.errorContext == 'PLAN_IN_PROGRESSING':
                    messageCon = i18n.t(`promptMessage.error1017`);
                    break;

                case res.errorContext == 'UPLOAD_FILE_ERROR':
                    messageCon = i18n.t(`promptMessage.1003FILE_UPLOAD`);
                    break;

                case res.errorContext == 'TEMPLATE_PLAN_NAME_DUPLICATE':
                    messageCon = i18n.t(`promptMessage.1002PLAN_DUPLICATE`);
                    break;

                case res.errorContext == 'AP_OFFLINE':
                    messageCon = i18n.t(`label.ap_offline`);
                    break;

                case ['APMAC_NOT_FOUND', 'HAPP_REQUEST_ERROR', 'APMAC_DUPLICATE', 'VERSION_DUPLICATE', 'PLAN_NOT_FOUND', 'PLAN_DUPLICATE', 'MIRROR_CENTER_REQUEST_FAILED',
                    'MIRROR_CENTER_CONFIG_NOT_COMPLETED', 'VERSION_IN_USED', 'SAVE_UPGRADE_PACKAGE_FAILED', 'EW_VERSION_NOT_SUPPORT', 'DOWNLOAD_FILE_ERROR', 'VERSION_NOT_FOUND', 'HAPP_REQUEST_NOT_SUPPORTED', 'HAPP_SYNC_CLOSED', 'VERSION_EXPIRED', 'TEMPLATE_PROJECT_NOT_EXIST', 'TEMPLATE_PLAN_IS_RUNNING', 'SENDER_DUPLICATE', 'SENDER_NOT_EXIST', 'SENDER_IS_USING', 'EMAIL_TASK_NOT_DISABLED'].includes(res.errorContext):
                    messageCon = i18n.t(`promptMessage.1002` + res.errorContext);
                    break;

                default: messageCon;
            }
        }

        else if (res.resultCode == 1003) {
            messageCon = i18n.t(`promptMessage.error1003`);
            switch (true) {
                case res.errorContext == 'template_domain':
                    messageCon = i18n.t(`promptMessage.distrubtRange`);
                    break;

                case res.errorContext == 'binds_exist':
                    messageCon = res.message + i18n.t(`promptMessage.binds_exist`);
                    break;

                case res.errorContext == 'eslId':
                    messageCon = i18n.t('promptMessage.1003eslId');
                    break;

                case res.errorContext == 'eslIdsNotExist':
                    messageCon = `${res.message + i18n.t('promptMessage.eslNoExist')}`;
                    break;

                case res.errorContext == 'macsNotExist':
                    messageCon = `${res.message + i18n.t('promptMessage.eslNoExist')}`;
                    break;

                case res.errorContext == 'sku':
                    messageCon = `${i18n.t('promptMessage.error1003sku')}`;
                    break;

                case res.errorContext == 'password': case res.errorContext == 'OLD_PASSWD_ILLEGAL':
                    messageCon = `${i18n.t('promptMessage.errorpassword')}`;
                    break;

                case res.errorContext == 'passRegNotMatch':
                    messageCon = `${i18n.t('promptMessage.errorpassRegNotMatch')}`;
                    break;


                case res.errorContext == 'addressOrPort':
                    messageCon = `${i18n.t('promptMessage.warnLayoutAddress')}`;
                    break;

                case res.errorContext == 'mail_password':
                    messageCon = `${i18n.t('promptMessage.warnLayoutPassword')}`;
                    break;

                case res.errorContext == 'roleName':
                    messageCon = `${i18n.t('promptMessage.errorroleName')}`;
                    break;

                case res.errorContext == 'storeCode':
                    if (res.message == 'storeCodeIllegal') {
                        messageCon = `${i18n.t('promptMessage.storeCodeIllegal')}`;
                    } else {
                        messageCon = `${i18n.t('promptMessage.1003StoreCode')}`;
                    }
                    break;

                case res.errorContext == 'hummerUrl':
                    messageCon = `${i18n.t('promptMessage.errorhummerUrl')}`;
                    break;

                case res.errorContext == 'hummerTest':
                    messageCon = `${i18n.t('promptMessage.1003hummerTest')}`;
                    break;

                case res.errorContext == 'templateRule':
                    messageCon = `${i18n.t('promptMessage.templateRule')}`;
                    break;

                case res.errorContext == 'subnet':
                    messageCon = `${i18n.t('promptMessage.subnet')}`;
                    break;

                case res.errorContext == 'firmwareId':
                    messageCon = `${i18n.t('promptMessage.1003firmwareId')}`;
                    break;

                case res.errorContext == 'rom':
                    messageCon = `${i18n.t('promptMessage.1003rom')}`;
                    break;

                case res.errorContext == 'apId':
                    messageCon = `${i18n.t('promptMessage.1003apId')}`;
                    break;

                case res.errorContext == 'report_config':
                    messageCon = `${i18n.t('promptMessage.1003reportConfig')}`;
                    break;

                case res.errorContext == 'report_config_temp_hour':
                    messageCon = `${i18n.t('promptMessage.1003tempHour')}`;
                    break;

                case res.errorContext == 'report_config_data_field':
                    messageCon = `${i18n.t('promptMessage.1003dataField')}`;
                    break;

                case res.errorContext == 'eslConfigName':
                    messageCon = `${i18n.t('promptMessage.1003eslConfigName')}`;
                    break;

                case res.errorContext == 'eslConfigEnable':
                    messageCon = `${i18n.t('promptMessage.1003eslConfigEnable')}`;
                    break;

                case res.errorContext == 'port':
                    messageCon = `${i18n.t('promptMessage.1003port')}`;
                    break;

                case res.errorContext == 'field':
                    messageCon = `${i18n.t('promptMessage.1003field')}${i18n.t('goods.' + res.message)}`;
                    break;

                case res.errorContext == 'goodsValue':
                    messageCon = `${i18n.t('promptMessage.1003field')}${res.message}`;
                    break;

                case res.errorContext == 'organizationUnitName':
                    messageCon = `${i18n.t('promptMessage.organizationNameReg')}`;
                    break;

                case res.errorContext == 'emailConfigName':
                    messageCon = `${i18n.t('promptMessage.1003emailConfigName')}`;
                    break;

                case res.errorContext == 'ZOOKEEPER_ADDRESS':
                    messageCon = `${i18n.t('promptMessage.1003ZOOKEEPER_ADDRESS')}`;
                    break;

                case res.errorContext == 'maximum':
                    messageCon = `${i18n.t('promptMessage.1003maximum')}${res.message}`;
                    break;

                case res.errorContext == 'disable_goods':
                    messageCon = i18n.t(`promptMessage.1003disable_goods`);
                    break;

                case res.errorContext == 'ESL_ID':
                    messageCon = `${i18n.t('promptMessage.1003ESL_ID')}`;
                    break;

                case res.errorContext == 'MOVE_CONFIG_NAME':
                    messageCon = `${i18n.t('promptMessage.1003MOVE_CONFIG_NAME')}`;
                    break;

                case res.errorContext == 'FILE': case res.errorContext == 'file':
                    messageCon = `${i18n.t('promptMessage.fileTypeError')}`;
                    break;

                case res.errorContext == 'whiteEslId':
                    messageCon = `${i18n.t('promptMessage.eslDeleteFailed')}`;
                    break;

                case res.errorContext == 'FILE_UPLOAD':
                    messageCon = `${i18n.t('promptMessage.1003FILE_UPLOAD')}`;
                    break;

                case res.errorContext == 'FILE_NAME': case res.errorContext == 'FILE_NAME_ILLEGAL':
                    messageCon = `${i18n.t('promptMessage.1003FILE_NAME')}`;
                    break;

                case res.errorContext == 'templateName':
                    messageCon = `${i18n.t('promptMessage.1003templateName')}`;
                    break;

                case res.errorContext == 'nfcCommunicationKey':
                    messageCon = `${i18n.t('promptMessage.1003nfcCommunicationKey')}`;
                    break;

                case res.errorContext == 'UNSUPPORT_UPLOAD':
                    messageCon = `${i18n.t('promptMessage.1003UNSUPPORT_UPLOAD')}`;
                    break;

                case res.errorContext == 'customerAllowEsl':
                    messageCon = `${i18n.t('promptMessage.custAllowEslEnable')}`;
                    break;

                case res.errorContext == 'storeAllowEsl':
                    messageCon = `${i18n.t('promptMessage.storeAllowEslEnable')}`;
                    break;

                case res.errorContext == 'apReplace':
                    messageCon = res.message;
                    break;

                case res.errorContext == 'temperatureEsl':
                    messageCon = `${i18n.t('promptMessage.1003temperatureEsl', { esl: res.message })}`;
                    break;


                case res.errorContext == 'CONFIG_ILLEGAL':
                    messageCon = `${i18n.t('promptMessage.1003CONFIG_ILLEGAL')}`;
                    break;

                case res.errorContext == 'goodsImport':
                    messageCon = `${i18n.t('promptMessage.1003goodsImport')}${res.data.sku}(${i18n.t('goods.sku')}): ${i18n.t('goods.' + res.data.title)}`;
                    break;

                case ['AP_MAC_ILLEGAL', 'CUSTOMER_CODE_ILLEGAL', 'STORE_CODE_ILLEGAL', 'VERSION_ILLEGAL', 'FILE_ILLEGAL', 'PLAN_NAME_ILLEGAL', 'SOURCE_ILLEGAL', 'UPGRADE_TYPE_ILLEGAL', 'UPGRADE_TIME_ILLEGAL', 'MIRROR_CENTER_URL_ILLEGAL', 'MIRROR_CENTER_USERNAME_ILLEGAL', 'MIRROR_CENTER_PASSWORD_ILLEGAL', 'NEW_PASSWD_ILLEGAL', 'APP_INFO_ILLEGAL', 'HAPP_CONFIG_ILLEGAL', 'DOWNLOAD_PROXY_NOT_CONFIG'].includes(res.errorContext):
                    messageCon = `${i18n.t('promptMessage.1003' + res.errorContext)}`;
                    break;


                case res.message == 'whiteUrlError':
                    messageCon = `${i18n.t('promptMessage.whiteUrlError')}`;
                    break;

                case res.message == 'customerCodeIllegal':
                    messageCon = `${i18n.t('promptMessage.customerCodeIllegal')}`;
                    break;

                case res.message == 'apSequence':
                    messageCon = `${i18n.t('promptMessage.1003apSequence')}`;
                    break;

                case res.message == 'no_modify':
                    messageCon = `${i18n.t('promptMessage.1003noModify')}`;
                    break;

                case res.message == 'startTimeDuplicat':
                    messageCon = `${i18n.t('promptMessage.1003startTimeDuplicat')}`;
                    break;

                case res.message == 'timeSlotEmpty':
                    messageCon = `${i18n.t('promptMessage.1003timeSlotEmpty')}`;
                    break;

                case ['IO_ERRORFILEFORMAT', 'REFRESH', 'IO_NOCSVFILE', 'IO_NONEFILE', 'reserved'].includes(res.message):
                    messageCon = i18n.t(`promptMessage.${res.message}`);
                    break;

                case res.message != 'Illegal arguments' && res.message != 'other':
                    messageCon = i18n.t(`promptMessage.${res.message}`);
                    break;

                default: messageCon;
            }
        }

        else if (res.resultCode == 1004) {
            messageCon = i18n.t(`promptMessage.error1004`);
            switch (res.errorContext) {
                case 'captchaExpired':
                    messageCon = `${i18n.t('promptMessage.1004captchaExpired')}`;
                    break;
                case 'captchaFailed':
                    messageCon = i18n.t(`promptMessage.1004captchaFailed`);
                    break;

                default: messageCon;
            }
        }

        else if (res.resultCode == 1005) {
            messageCon = i18n.t(`promptMessage.error1005`);
        }

        else if (res.resultCode == 1006) {
            messageCon = i18n.t(`promptMessage.error1006`);
            if (res.errorContext == 'hummerUrl') {
                messageCon = `${i18n.t(`promptMessage.1006hummerUrl`)}`;
            }
        }

        else if (res.resultCode == 1007) {
            messageCon = i18n.t(`promptMessage.error1007`);
            store.dispatch('user/logoutClear', res.data);
        }

        else if (res.resultCode == 1008 || res.resultCode == 1103) {
            messageCon = i18n.t(`promptMessage.error${res.resultCode}`);
            let data = res.data || {};
            // 整体的锁定功能
            if (res.data) {
                let { remainLoginErrorTimes, loginErrorTimeout, remainLockCount, loginLockLimitTimeout, lockTimes } = data;

                //清除pas次数时间，单位:s
                let pasTime = getNoZeroCostTime(loginErrorTimeout * 1000);
                //清除临时锁定次数时间，单位：s
                let foreverTime = getNoZeroCostTime(loginLockLimitTimeout * 1000);

                //是否有永久锁定
                let mesData = {};
                if (remainLockCount != null) {
                    //无剩余锁定次数
                    if (remainLockCount == 1) {
                        mesData = {
                            pasTime,
                            tryCount: remainLoginErrorTimes,
                            foreverTime,
                            remainLockCount,
                            lockTimes,
                        };
                        messageCon = i18n.t('promptMessage.1008Condition2', mesData);
                    } else {
                        mesData = {
                            pasTime,
                            tryCount: remainLoginErrorTimes,
                            foreverTime,
                            remainLockCount,
                            lockTimes,
                        };
                        messageCon = i18n.t('promptMessage.1008Condition1', mesData);
                    }
                } else {
                    mesData = {
                        pasTime,
                        tryCount: remainLoginErrorTimes,
                    };
                    messageCon = i18n.t('promptMessage.1008Condition3', mesData);
                }
            }
        }

        else if (res.resultCode == 1009) {
            messageCon = i18n.t(`promptMessage.error1009`);
            switch (true) {
                case res.errorContext == 'hummerVersion':
                    messageCon = `${i18n.t('promptMessage.1009hummerVersion')}`;
                    break;

                case res.errorContext == 'happ_routing':
                    messageCon = `${i18n.t('promptMessage.1009happRouting')}`;
                    break;

                case res.errorContext == 'productSeriesType':
                    messageCon = i18n.t(`promptMessage.1009productSeriesType`);
                    break;

                case ['TEMPLATE_PLAN_NOT_FOUND'].includes(res.errorContext):
                    messageCon = i18n.t(`promptMessage.1009${res.errorContext}`);
                    break;

                case res.errorContext == 'apReplace':
                    messageCon = res.message;
                    break;

                case res.message == 'apId':
                    messageCon = i18n.t(`promptMessage.1009apId`);
                    break;

                default: messageCon;
            }
        }

        else if (res.resultCode == 1011) {
            messageCon = i18n.t(`promptMessage.error1011`);
            switch (true) {
                case res.errorContext == 'sku':
                    messageCon = `${i18n.t('promptMessage.errorsku')}`;
                    break;

                case res.errorContext == 'cust_sku':
                    messageCon = `${i18n.t('promptMessage.error1011sku')}`;
                    break;

                case res.errorContext == 'storeCode':
                    messageCon = `${i18n.t('promptMessage.errorstoreCode')}`;
                    break;

                case res.errorContext == 'mapName':
                    messageCon = `${i18n.t('promptMessage.error1011mapName')}`;
                    break;

                case res.errorContext == 'ou_path':
                    messageCon = `${i18n.t('promptMessage.error1011ou_path')}`;
                    break;

                case res.errorContext == 'username':
                    messageCon = `${i18n.t('promptMessage.errorusername')}`;
                    break;

                case res.errorContext == 'timeGroupName':
                    messageCon = i18n.t(`promptMessage.error1011timeGroupName`);
                    break;

                case res.errorContext == 'roleName':
                    messageCon = i18n.t(`promptMessage.errorroleName`);
                    break;

                case res.errorContext == 'storeName':
                    messageCon = i18n.t(`promptMessage.errorstoreName`);
                    break;

                case res.errorContext == 'customerCode':
                    messageCon = i18n.t(`promptMessage.errorcustomerCode`);
                    break;

                case res.errorContext == 'customerName':
                    messageCon = i18n.t(`promptMessage.errorcustomerName`);
                    break;

                case res.errorContext == 'happ':
                    messageCon = i18n.t(`promptMessage.error1011happ`);
                    break;

                case res.errorContext == 'organizationUnitName':
                    messageCon = `${i18n.t('promptMessage.1011organizationUnitName')}`;
                    break;

                case res.errorContext == 'position':
                    messageCon = i18n.t(`promptMessage.error1011position`);
                    break;

                case res.errorContext == 'task':
                    messageCon = `${i18n.t('promptMessage.1011task')}`;
                    break;

                case res.errorContext == 'tagValue':
                    messageCon = `${i18n.t('promptMessage.1011tagValue')}`;
                    break;

                case res.errorContext == 'HUMMER_NAME':
                    messageCon = `${i18n.t('promptMessage.1011hummerName')}`;
                    break;

                case res.errorContext == 'productSeriesType':
                    messageCon = `${i18n.t('promptMessage.1011productSeriesType')}`;
                    break;

                case res.errorContext == 'shelfCode':
                    messageCon = `${i18n.t('promptMessage.1011shelfCode')}`;
                    break;

                case res.errorContext == 'command':
                    messageCon = `${i18n.t('promptMessage.command')}`;
                    break;

                case res.errorContext == 'HUMMER_SERVER_ID':
                    messageCon = `${i18n.t('promptMessage.1011hummerServerId')}`;
                    break;

                case res.message == 'url':
                    messageCon = `${i18n.t('promptMessage.1011hummerUrl')}`;
                    break;

                case ['command', 'reserved', 'roleName'].includes(res.message):
                    messageCon = i18n.t(`promptMessage.${res.message}`);
                    break;

                default: messageCon;
            }
        }

        else if (res.resultCode == 1012) {
            messageCon = i18n.t(`promptMessage.error1012`);
        }

        else if (res.resultCode == 1014) {
            if (res.data) {
                let { remainLockCount, loginLockLimitTimeout, lockTimes, remainLockTime } = res.data;
                let remainTime = getNoZeroCostTime(remainLockTime * 1000);
                let foreverTime = getNoZeroCostTime(loginLockLimitTimeout * 1000);
                if (remainLockCount != null) {
                    let mesData = {
                        foreverTime,
                        lockTimes,
                        remainLockCount,
                        remainTime,
                    };
                    messageCon = i18n.t('promptMessage.1014Lock', mesData);
                } else {
                    messageCon = i18n.t('promptMessage.1014Lock2', { remainTime });

                }
                if (res.data?.lockedToLogout) {
                    store.dispatch('user/logoutClear', res.data);
                }
            } else {
                let socendNum = res.message.slice(res.message.indexOf('[') + 1, res.message.lastIndexOf(']'));
                let remainTime = getNoZeroCostTime(socendNum * 1000);
                messageCon = i18n.t('promptMessage.error1014', { remainTime });
                if (res?.data?.lockedToLogout) {
                    store.dispatch('user/logoutClear', res.data);
                }
            }

        }

        else if (res.resultCode == 1015) {
            messageCon = i18n.t(`promptMessage.error1015`);
        }

        else if (res.resultCode == 1017) {
            messageCon = i18n.t(`promptMessage.error1017`);
            switch (true) {
                case res.message == 'apSequence':
                    messageCon = i18n.t(`promptMessage.1017apSequence`);
                    break;

                case res.errorContext == 'customerTimezone':
                    messageCon = `${res.message}${i18n.t(`promptMessage.customerTimezone`)}`;
                    break;

                case res.errorContext == 'groupId':
                    messageCon = i18n.t(`promptMessage.1017groupId`);
                    break;

                case res.errorContext == 'organizationUnitCode':
                    messageCon = i18n.t(`promptMessage.1017organizationUnitCode`);
                    break;

                case res.errorContext == 'eslInventory':
                    messageCon = i18n.t(`promptMessage.1017eslInventory`);
                    break;

                case res.errorContext == 'tagCode':
                    messageCon = i18n.t(`promptMessage.1017tagCode`);
                    break;

                case res.errorContext == 'eslConfig':
                    messageCon = i18n.t(`promptMessage.1017eslConfig`);
                    break;

                case res.errorContext == 'virtualEsl':
                    messageCon = i18n.t(`promptMessage.1017virtualEsl`);
                    break;

                case res.errorContext == 'virtualEslExist':
                    messageCon = i18n.t(`promptMessage.1017virtualEslExist`);
                    break;

                case res.errorContext == 'templateAllocationExists':
                    messageCon = i18n.t(`promptMessage.1017templateAllocationExists`);
                    break;

                case ['TEMPLATE_PROJECT_IS_USING'].includes(res.errorContext):
                    messageCon = i18n.t(`promptMessage.1017${res.errorContext}`);
                    break;

                default: messageCon;
            }
        }

        else if (res.resultCode == 1018) {
            notShowNotify = true;
            messageCon = i18n.t(`promptMessage.error1018`);
            let type = 'init';
            if (res.errorContext == 'oldPassword') {
                type = 'old';
            }
            router.push({ name: 'modifyPassword', query: { userName: res.data.username, type } });
        }

        else if (res.resultCode == 1020) {
            messageCon = i18n.t(`promptMessage.error1020`);

            switch (true) {
                case res.errorContext == 'no_store':
                    messageCon = i18n.t(`promptMessage.1020noStore`);
                    break;

                case res.errorContext == 'eslConfig':
                    messageCon = i18n.t(`promptMessage.1020eslConfig`);
                    break;

                default: messageCon;
            }
        }

        else if (res.resultCode == 1021) {
            messageCon = i18n.t(`promptMessage.error1021`);

            switch (true) {
                case res.errorContext == 'customerCode': case res.errorContext == 'customerName': case res.errorContext == 'storeCode': case res.errorContext == 'storeName':
                    messageCon = `${i18n.t(`label.` + res.errorContext)} ${messageCon}`;
                    break;

                case res.errorContext == 'username':
                    messageCon = `${i18n.t(`label.userName`)} ${messageCon}`;
                    break;

                case res.errorContext == 'roleName':
                    messageCon = `${i18n.t(`label.userGroup`)} ${messageCon}`;
                    break;

                case res.errorContext == 'organizationUnitName':
                    messageCon = `${i18n.t(`label.organizationName`)} ${messageCon}`;
                    break;

                default: messageCon;
            }
        }

        else if (res.resultCode == 1024) {
            messageCon = i18n.t(`promptMessage.error1024`);
        }

        else if (res.resultCode == 1025) {
            messageCon = i18n.t(`promptMessage.error1025`);
        }

        else if (res.resultCode == 1026) {
            notShowNotify = true;
            messageCon = i18n.t(`promptMessage.error1026`);
        }
        else if (res.resultCode == 1027) {
            notShowNotify = true;
            router.push({ name: 'mfa', query: { userName: res.data.username, bindStatus: res.data.bindStatus } });
        }

        else if (res.resultCode == 1028) {
            messageCon = i18n.t(`promptMessage.error1028`);
            if (router?.currentRoute?.name != 'login') {
                setTimeout(() => {
                    store.dispatch('user/logoutClear', res.data);
                }, 500);
            }
        }

        else if (res.resultCode == 1029) {
            messageCon = i18n.t(`promptMessage.error1029`, { count: res?.data?.limitPdTimes || 0 });
        }

        else if (res.resultCode == 1101) {
            messageCon = i18n.t(`promptMessage.error1101`);
        }

        else if (res.resultCode == 1102) {
            messageCon = i18n.t(`promptMessage.error1102`);

        }

        else if (res.resultCode == 1111) {
            let stores = res.data || [];
            messageCon = i18n.t(`promptMessage.error1111`, { store: stores.join(',') });
        }

        else if (res.resultCode == 1116) {
            // notShowNotify = true;
            messageCon = i18n.t(`promptMessage.error1116`);
        }

        else if (res.resultCode == 1120) {
            messageCon = i18n.t(`promptMessage.error1120`);
        }

        else if (res.resultCode == 1121) {
            messageCon = i18n.t(`promptMessage.error1121`);
        }

        else if (res.resultCode == 1201) {
            messageCon = 'promptMessage.error1201';
            switch (true) {
                case res.errorContext == 'storeDeleted':
                    messageCon = i18n.t(`promptMessage.1201storeDeleted`);
                    break;

                case res.errorContext == 'taskStatus':
                    messageCon = i18n.t(`promptMessage.1201taskStatus`);
                    break;

                case res.errorContext == 'AP':
                    messageCon = i18n.t(`promptMessage.1201AP`);
                    break;

                default: messageCon;
            }
            messageCon = i18n.t(messageCon);
        }

        else if (res.resultCode == 1202) {
            messageCon = i18n.t(`promptMessage.error1202`);
            switch (true) {
                case res.errorContext == 'organizationUnitName':
                    messageCon = `${i18n.t('promptMessage.1202organizationUnitName')}${res.message || ''}`;
                    break;

                case res.errorContext == 'apReplace':
                    messageCon = res.message;
                    break;

                case res.errorContext == 'EW_VERESION_NOT_SUPPORT':
                    messageCon = `${i18n.t('promptMessage.1202noSupportEW')}`;
                    break;

                default: messageCon;
            }
        }

        else if (res.resultCode == 1301) {
            messageCon = i18n.t(`promptMessage.error1301`);
        }

        else if (res.resultCode == 1501) {
            messageCon = i18n.t(`promptMessage.error1501`);
        }
        else if (res.resultCode == 1502) {
            messageCon = i18n.t(`promptMessage.error1502`);
        }

        else if (res.resultCode == 1601) {
            messageCon = i18n.t(`promptMessage.error1601`);
        }

        else if (res.resultCode == 3000) {
            messageCon = i18n.t(`promptMessage.error3000`);
            res.errorContext == 'licenseUpload' ? messageCon = i18n.t(`promptMessage.error3000licenseUpload`) : '';
        }
        else if (res.resultCode == 3001) {
            messageCon = i18n.t(`promptMessage.error3001`);
        }
        else if (res.resultCode == 3002) {
            messageCon = i18n.t(`promptMessage.error3002`);
            res.errorContext == 'licenseUpload' ? messageCon = i18n.t(`promptMessage.error3002licenseUpload`) : '';

        }
        else if (res.resultCode == 3003) {
            messageCon = i18n.t(`promptMessage.error3003`);
        }
        else if (res.resultCode == 3004) {
            messageCon = i18n.t(`promptMessage.error3004`);
        }
        else if (res.resultCode == 3005) {
            messageCon = i18n.t(`promptMessage.error3005`);
        }
        else if (res.resultCode == 3006) {
            messageCon = i18n.t(`promptMessage.error3006`);
        } else {
            if (res.resultCode) {
                messageCon = res.errorContext ? i18n.t(`promptMessage.${res.resultCode}${res.errorContext}`) : i18n.t(`promptMessage.error${res.resultCode}`);
            }
        }

        if (res.resultCode && !notShowNotify) {
            Notification({
                message: messageCon ? messageCon : i18n.t(`promptMessage.error${res.resultCode}`),
                type: 'error'
            });
        }

    }


}